module.exports = __webpack_public_path__ + "img/img3.d5645fb0.png";